import { Store } from '../../../store/player/types';
import { pause } from './pause';
import { hasNextRecording } from './hasNextRecording';
import { nextRecording } from './nextRecording';

/**
 * Finish the recording.
 */
export const finishRecording = (store: Store): void => {
  const {
    isAutoplaying,
    isSharedRecording,
    setNextRecordingCountdown,
    setDone,
    setCancelledNextRecordingCountdown,
    setShowPollUpsell,
  } = store.getState();

  pause(store);

  setDone(true);
  setCancelledNextRecordingCountdown(false);

  if (hasNextRecording(store) && isAutoplaying && !isSharedRecording) {
    setNextRecordingCountdown(+setTimeout(() => nextRecording(store), 8000));
  } else {
    setShowPollUpsell(true);
  }
};
